import { render, staticRenderFns } from "./FormFieldHeader.vue?vue&type=template&id=1317ecd7"
import script from "./FormFieldHeader.vue?vue&type=script&lang=ts"
export * from "./FormFieldHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports